<template>
  <div>

    <v-app>
      <div
        data-app
        class="wrapper"
        :class="[
          { 'nav-open': $sidebar.showSidebar },
          { rtl: $route.meta.rtlActive },
        ]"
      >
        <notifications></notifications>
        <side-bar
          :active-color="sidebarBackground"
          :background-image="sidebarBackgroundImage"
          :data-background-color="sidebarBackgroundColor"
        >
          <!-- <user-menu></user-menu> -->
          <mobile-menu></mobile-menu>
          <template slot="links">
            <sidebar-item v-for="item in menu" :key="item.path" :link="item" :visible="item.visible"/>

            <!-- temporarily removed -->
            <!-- :disabled="item.disabled" -->
          </template>
        </side-bar>
        <div class="main-panel">
          <top-navbar showHelpIcon>
            <search-bar class="md-layout-item md-size-30" />
            <live-auction-bar class="md-layout-item md-size-15" />
            <div v-if="canSendMock" class="md-layout-item md-size-5" md-align="end" style="display: flex; justify-content: center; align-items: center;">
              <notification-bell @toggle="handleToggleBell" />
            </div>
            <application-bar class="md-layout-item md-size-30" />
          </top-navbar>
          

          <div
            class="scroll-area"
            :class="{ content: !$route.meta.hideContent }"
            @click="toggleSidebar"
          >
            <zoom-center-transition
              :duration="200"
              mode="out-in"
              class="zoom-container"
            >
              <!-- your content here -->
              <router-view></router-view>
            </zoom-center-transition>
            <content-footer v-if="!$route.meta.hideFooter"></content-footer>
          </div>
          <main-side-drawer
            :visible="drawerVisible"
            :activeDrawerType="activeDrawerType"
          />
        </div>
      </div>

      <notification-toast-stack
        :toasts="toastQueue"
        @clicked="handleToastClick"
        @remove="removeToast"
      />
      <notification-maintenance
        v-if="maintenanceNotification !== null"
        :notification="maintenanceNotification"
      />
      <notification-sidebar 
      v-model="notificationDrawerVisible" 
      :key="notificationDrawerVisible"/>
      <popup-dispatcher />
    </v-app>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import ApplicationBar from "@/components/ApplicationBar";
import SearchBar from "@/components/Search/SearchBar";
import LiveAuctionBar from "@/components/LiveAuction/LiveAuctionBar";
import MainSideDrawer from "@/components/SideDrawer/MainSideDrawer.vue";
import { v4 as uuidV4 } from 'uuid';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    // initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

import TopNavbar from "@/pages/Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "@/pages/Dashboard/Layout/ContentFooter.vue";
import MobileMenu from "@/pages/Dashboard/Layout/Extra/MobileMenu.vue";
import FixedPlugin from "../FixedPlugin.vue";
import UserMenu from "@/pages/Dashboard/Layout/Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import { mapGetters, mapState } from 'vuex';
import SessionExpiredDialog from "../../components/Dialogs/SessionExpiredDialog.vue";

import NotificationSidebar from '@/components/Notification/NotificationSidebar.vue';
import NotificationToastStack from '@/components/Notification/NotificationToastStack.vue';
import PopupDispatcher from '@/components/Notification/PopupDispatcher.vue';
import NotificationBell from '@/components/Notification/NotificationBell.vue';
import NotificationMaintenance from '@/components/Notification/NotificationMaintenance.vue';

async function loadApplicationFromRouteParam(vue, to, from = null) {
  let application_id = to.params.id;
  let application_id_int = parseInt(application_id);
  if (to.name == 'Capture' && application_id_int > 0 && vue.userHasPermission('bypass-application-lock') === false) {
    if (await vue.$store.dispatch('check_application_lock', to.params.id) == false) {
      if (from != null) {
        await vue.$store.dispatch('release_application_lock', from.params.id);
      }
      return false
    }
  }
  // do not need to set application if it is going to admin page
  const toPath = to.path.split('/');
  const index = toPath.findIndex( ele => ele.toLowerCase() == "administration" );
  if(application_id != vue.$store.getters.application_status.id && index == -1){
    if(application_id == 'new'){
      vue.$store.commit('setApplicationStatus', {id: application_id});
      vue.$store.dispatch('load_blank_application');
    }else if(application_id_int > 0){
      vue.$store.commit('setApplicationStatus', {id: application_id});
      vue.$store.dispatch('load_application', application_id);
    }else{
      console.error('unable to load application from url parameter:', application_id);
    }
  }
}

async function loadTypes(vue, types=[]) {
  const params = {
    types,
  }
  await vue.$store.dispatch('fetch_types', { params });
  return true
}

export default {
  components: {
    TopNavbar,
    ContentFooter,
    FixedPlugin,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition,
    ApplicationBar,
    SearchBar,
    LiveAuctionBar,
    MainSideDrawer,
    NotificationSidebar,
    NotificationBell,
    NotificationToastStack,
    PopupDispatcher,
    NotificationMaintenance
  },
  data() {
    return {
      sessionExpired: false,
      sidebarBackgroundColor: "black",
      sidebarBackground: "blue",
      sidebarBackgroundImage: require("@/assets/img/sidebar-2.jpg"),
      sidebarMini: true,
      sidebarImg: true,
      drawerVisible: false,
      activeDrawerType: "",
      notificationDrawerVisible: false,
    };
  },
  props: {
    menu: {
      type: Array,
      default: [],
    },
  },
  computed: {
    ...mapGetters([
      "userOnlyHasRole",
      "application",
      "application_status",
      "userHasPermission",
      "current_lock",
      "is_editing",
      "show_live_auction_drawer",
      "isPodManager",
      "userHasRole",
      "user"
    ]),
    ...mapGetters('notifications', ['canSendMock']),
    ...mapState('notifications', ['toastQueue', 'maintenanceOverlay']),
    maintenanceNotification() {
      return this.maintenanceOverlay || null;
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    calculateDaysLeft() {
      const today = new Date();
      const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Last day of the current month
      const daysLeft = Math.ceil((lastDayOfMonth - today) / (1000 * 60 * 60 * 24)); // Difference in days

      return daysLeft;
    },
    async subscribeToUserNotificationsPusher() {
      if (!this.user?.id) return;

      const channelName = `private-App.Models.User.${this.user.id}`;
      const { channel } = await this.$store.dispatch('subscribe_to_pusher_channel', channelName);

      if (channel === null) {
        console.error('❌ Failed to subscribe to notification channel:', channelName);
        return;
      }

      channel.bind('Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', (notification) => {
        const normalized = {
          ...notification,
          notification_id: notification.notification_id || notification.id || uuidV4(),
        };
        console.log('✅ Normalized notification:', normalized);

        this.$store.commit('notifications/add', normalized);
        this.$store.commit('notifications/setToast', normalized);
      });

    },
    async subscribeToGlobalNotificationsPusher() {
      const { channel } = await this.$store.dispatch('subscribe_to_pusher_channel', 'global');

      if (channel === null) {
        console.error('❌ Failed to subscribe to global notification channel');
        return;
      }

      console.log('📡 Channel object:', channel);

      channel.bind('GlobalNotification', (notification) => {
        console.log('🌍 Global notification received:', notification);

        const normalized = {
          ...notification,
          notification_id: notification.notification_id || notification.id || uuidV4(),
        };

        console.log('🌍 Global normalized received:', normalized);

        if (normalized.notification_type === 'maintenance') {
          this.$store.commit('notifications/setMaintenanceOverlay', normalized);
        }
      });
    },
    handleToastClick() {
      this.$store.commit('notifications/clearToast'); // Keep if legacy `toast` is still in use
      //this.$store.dispatch('notifications/markRead', notification.notification_id);
    },
    removeToast(index) {
      this.$store.commit('notifications/removeToast', index);
    },
    async subscribeToBrokerNotificationsPusher() {
      if (!this.userHasRole('super-admin') && !this.isPodManager && !this.userHasRole('Broker')) {
        return;
      }

      if (this.user.id === "" || this.user.id == null) {
        return;
      }

      const daysLeft = this.calculateDaysLeft();
      
      if (daysLeft < 7) {
          return;
      }
      
      const channelName = `broker-notifications-channel.${this.user.id}`;
      const { channel } = await this.$store.dispatch('subscribe_to_pusher_channel', channelName);
      if (channel === null) {
        console.error('Failed to subscribe to channel:', channelName);
        return;
      }
      channel.bind("broker-notifications", () => {
        const message = `Hi, the Lead Request Form for next month is now available in ZINK.
           Please submit your lead requirements before end of month. <a href="/application/new/tools/partner-leads" target="_blank">Click here</a>.`;
        this.$notifications.notify({
          'message': message,
          'timeout': 300000,
          'verticalAlign': 'top',
          'horizontalAlign': 'center',
          'hardNotification': true
        });
      });
    },
    handleToggleBell() {
      this.notificationDrawerVisible = !this.notificationDrawerVisible;
      console.log(`[Layout] 🧲 handleToggleBell triggered: ${this.notificationDrawerVisible}`);
    },
    async checkSession() {
      const sessionCookie = document.cookie.split(';')
        .find((cookie) => cookie.trim().startsWith('session_expiration='));
      if (sessionCookie) {
        return;
      }
      clearInterval(this.checkSessionInterval);
      this.sessionExpired = true;
    },
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
    // this.subscribeToBrokerNotificationsPusher();
    this.$store.dispatch('notifications/checkMockNotificationPermission');
    this.checkSessionInterval = setInterval(this.checkSession, 10*1000);
    this.checkSession();

    // start notifications
    this.subscribeToUserNotificationsPusher();
    this.subscribeToGlobalNotificationsPusher();
    this.$store.dispatch('notifications/fetch');
  },
  watch: {
    show_live_auction_drawer(val) {
      if(val){
        this.activeDrawerType = 'Live Auctions';
      }
      this.drawerVisible = val;
    },
    sidebarMini() {
      this.minimizeSidebar();
    },
    sessionExpired(value) {
      if (!value) {
        return;
      }
      clearInterval(this.checkSessionInterval);

      // Lock application until user logs back in
      const showSessionExpiredDialog = () => {
        this.$modal.show(SessionExpiredDialog)
          .catch((_reason) => {
            showSessionExpiredDialog();
          });
      };
      showSessionExpiredDialog();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      loadApplicationFromRouteParam(vm, to, from);
      await loadTypes(vm, to.meta?.types ?? []);
    });
  },
  async beforeRouteUpdate(to, from, next) {
    // TODO: Add back in next iteration
    /** if (to.name === 'Workbasket' && parseInt(from.params.id) > 0 && this.userHasPermission('bypass-application-lock') === false) {
      this.$store.dispatch('release_application_lock', from.params.id)
    } **/
    if (vue.$store.getters.is_editing === true) {
      return false;
    }
    if (await loadApplicationFromRouteParam(this, to, from) == false) {
      this.$notifications.notify({
        'message': this.current_lock.messages,
        'icon': 'lock',
        'timeout': 5000,
        'verticalAlign': 'top',
        'horizontalAlign': 'center'
      })
      vue.$router.push(`/application/${this.current_lock.app_id}/summary`);
      return false
    }
    await loadTypes(this, to.meta?.types ?? []);
    next();
  },
  async created() {
    if (await loadApplicationFromRouteParam(this, this.$route) == false) {
      this.$notifications.notify({
        'message': this.current_lock.messages,
        'icon': 'lock',
        'timeout': 5000,
        'verticalAlign': 'top',
        'horizontalAlign': 'center'
      })
      this.$router.push('./basket')
    }
  },
  beforeDestroy() {
    clearInterval(this.checkSessionInterval);
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/theme.scss";
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.main-panel .scroll-area {
  overflow-y: scroll;
  overflow-x: auto;
  height: calc(100vh - 72px);
  padding: 0px;
}
.main-panel .scroll-area .zoom-container {
  margin: 0px 15px 10px 0px;
}
.main-panel h3.md-title {
  display: none;
}
.logout-btn {
  background-color: transparent;
}
</style>
